import { eIPORoutes } from "../routes";
import _ from "lodash";
import { useLocation, Route, Switch } from "react-router-dom";
import React from "react";
import NotFound from "../views/404";
import EIPODetail from "../views/EIPODetail";
import EIPOSubscribe from "../views/EIPOSubscribe";
import EIPOSubscribeContracts from "../views/EIPOSubscribe/scenes/EIPOSubscribeContracts";
import EIPOSubscribeConfirmation from "../views/EIPOSubscribe/scenes/EIPOSubscribeConfirmation";
import EIPOSubscribeDetail from "../views/EIPOSubscribeDetail";
import EIPOHistory from "../views/EIPOHistory";
import { withIpoConfig } from "../hooks/withIpoConfig";
import EIPOHistoryDetail from "../views/EIPOHistory/scenes/EIPOHistoryDetail";

function EIPOLayout({ipoConfig}) {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route exact path={`${prop.path}`} render={(props) => <prop.component {...props} />} key={key} />
      );
    });
  };
  return (
    <Switch>
      {getRoutes(eIPORoutes)}
      {/*<Route path="/dashboard/e-ipo/detail/:ipoID/*" component={NotFound} />*/}
      {/*<Route*/}
      {/*  path="/dashboard/e-ipo/detail/:ipoID"*/}
      {/*  render={(props) => <EIPODetail {...props} />}*/}
      {/*/>*/}
      {/*<Route path="/dashboard/e-ipo/subscribe/:ipoID/contracts/*" component={NotFound} />*/}

      {/*<Route*/}
      {/*  path="/dashboard/e-ipo/subscribe/:ipoID/contracts"*/}
      {/*  render={(props) => <EIPOSubscribeContracts {...props} />}*/}
      {/*/>*/}

      <Route path="/dashboard/e-ipo/subscribe/:ipoID/confirmation/*" component={NotFound} />

      <Route
        path="/dashboard/e-ipo/subscribe/:ipoID/confirmation"
        render={(props) => <EIPOSubscribeConfirmation ipoConfig={ipoConfig} {...props} />}
      />

      {/*<Route path="/dashboard/e-ipo/subscribe/detail/:ipoID/*" component={NotFound} />*/}

      {/*<Route*/}
      {/*  path="/dashboard/e-ipo/subscribe/detail/:ipoID"*/}
      {/*  render={(props) => <EIPOSubscribeDetail {...props} />}*/}
      {/*/>*/}
      <Route path="/dashboard/e-ipo/subscribe/:ipoID/*" component={NotFound} />

      <Route path="/dashboard/e-ipo/subscribe/:ipoID" render={(props) => <EIPOSubscribe ipoConfig={ipoConfig} {...props} />} />

      <Route path="/dashboard/e-ipo/history/:ipoID/*" component={NotFound} />

      <Route path="/dashboard/e-ipo/history/:ipoID" render={(props) => <EIPOHistoryDetail ipoConfig={ipoConfig} {...props} />} />

      <Route path="/dashboard/e-ipo/history" render={(props) => <EIPOHistory ipoConfig={ipoConfig} {...props} />} />

      <Route path={`*`} component={NotFound} key="not-found" />
    </Switch>
  );
}

export default withIpoConfig(EIPOLayout);
